/* Décalage à appliquer sous le header fixe */
function anchorOffset() {
  return $('.header__main').outerHeight() + 40
}

/* Le lien pointe-t-il vers une ancre du document courant? */
function sameDocumentHash(href) {
  if (!href) return null

  var index = href.indexOf('#')
  if (index === -1) return null

  var hash = href.slice(index)
  if (hash === '#') return null

  try {
    var url = new URL(href, window.location.href)
    if (url.origin !== window.location.origin) return null
    if (url.pathname !== window.location.pathname) return null
  } catch (e) {
    return null
  }

  return $(hash).length > 0 ? hash : null
}

function scrollToHash(hash) {
  $('html, body').scrollTo($(hash).offset().top - anchorOffset(), 400, 5, 'easeInOutQuart')

  if (window.history.replaceState) {
    window.history.replaceState(null, '', hash)
  }
}

/* Délégation: couvre aussi les liens que le menu ajoute au DOM après l'init */
$(function() {
  $(document).on('click', 'a[href*="#"]', function() {
    var hash = sameDocumentHash($(this).attr('href'))
    if (!hash) return

    scrollToHash(hash)
    return false;
  });
});

/* Scroll to hash on page load */
$(function() {
  if (window.location.hash) {
    var $target = $(window.location.hash);
    if ($target.length > 0) {
      setTimeout(function() {
        $('html, body').scrollTop($target.offset().top - anchorOffset());
      }, 100);
    }
  }
});
